import React from 'react';
import {Link} from 'react-router-dom';

import {FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter} from 'react-icons/fa';
import { Container, Row, Col } from 'reactstrap';


function Footer() {

    return(
        <div style={{backgroundColor:'white'}}>
            <Container style={{paddingTop:'30px'}}>

            <p style={{fontSize:'12px', color:'#767676'}}>
            Animée par le processus de création et l’esprit d’équipe, 
            de par mon passé professionnel d’architecte et de musicienne. 
             J'aime les challenges et j'ai le souci du code propre. 
             D'ailleurs voici une citation de John Woods que j'affectionne et qui 
             me fait toujours sourire : "Codez toujours comme si la personne qui allait 
             maintenir votre code était un violent psychopathe qui sait où vous habitez".
</p>

{/* LIGNE --------------------------------------------------------------------*/}
        <div style={{height:'1px', width:'100%', backgroundColor:'#ddd'}}></div>

{/* LIENS --------------------------------------------------------------------*/}
        <Row style={{marginTop:'10px'}}>
            {/* Liens site --------------------------------------------------------------------*/}
            <Col>
                <p style={{fontSize:'12px', fontWeight:'bold'}}>Mon profil développeur</p>
                    <p><Link to="/" style={{fontSize:'12px', color:'#767676'}}>Accueil</Link></p>
                    <p><Link to="/productions" style={{fontSize:'12px', color:'#767676'}}>Réalisations</Link></p>
                    <p><Link to="/formations" style={{fontSize:'12px', color:'#767676'}}>CV</Link></p>
                    <p><a href="https://github.com/MadameZ?tab=repositories" name="github" style={{fontSize:'12px', color:'#767676'}}>Github</a></p>
                    <p><Link to="/contact" style={{fontSize:'12px', color:'#767676'}}>Contact</Link></p>
            </Col>
            {/* Liens artistiques --------------------------------------------------------------------*/}
            <Col>
                <p style={{fontSize:'12px', fontWeight:'bold'}}>Autres créations</p>     
                    <p><a href="https://groovejourney.com/" name="grooveJourney" style={{fontSize:'12px', color:'#767676'}}>sonores</a></p>
      
                    <p><Link to="/architecture" style={{fontSize:'12px', color:'#767676'}}>Images</Link></p>
            </Col>
             {/* Références --------------------------------------------------------------------*/}
            <Col>
                <p style={{fontSize:'12px',fontWeight:'bold'}}>Mes références</p>
                <p><a href="https://www.youtube.com/channel/UCuP2vJ6kRutQBfRmdcI92mA" name="référenceiOS" style={{fontSize:'12px', color:'#767676'}}>Développement iOS</a></p>
                <p><a href="https://www.youtube.com/channel/UCj_iGliGCkLcHSZ8eqVNPDQ" name="référenceWeb" style={{fontSize:'12px', color:'#767676'}}>Développement web</a></p>
            </Col>
             {/* Logo --------------------------------------------------------------------*/}
            <Col>
            <h2>Caroline Zaini</h2>
            <a href="https://www.linkedin.com/in/📱caroline-zaini-7606b866/" name="Linkedin"><FaLinkedinIn size={30} color={'black'}/></a>
            <a href="https://www.facebook.com/zainicaroline" name="facebook"><FaFacebookF size={30} color={'black'}
                                                                    style={{marginLeft:'35px'}}
                                                                    /></a>
            <a href="https://www.instagram.com/caroline.zaini.m/?hl=fr" name="instagram"><FaInstagram size={30} color={'black'}
                                                                    style={{marginLeft:'35px'}}
                                                                    /></a>
            <a href="https://twitter.com/MadameZ_band" name="twitter"><FaTwitter size={30} color={'black'}
                                                                    style={{marginLeft:'35px'}}
                                                                    /></a>

            </Col>

        </Row>
        {/* LIGNE --------------------------------------------------------------------*/}
        <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#ddd'}}></div>
        {/* INFO --------------------------------------------------------------------*/}
        <Row style={{marginTop:'0px', marginBottom:'20px'}}>
            <Col>
            <p style={{fontSize:'12px', color:'#767676'}}>Copyright © 2020 Caroline Zaini. Tous droits réservés.</p>
            </Col>
            <Col>
            <p style={{fontSize:'12px', textAlign:'right', color:'#767676'}}>Paris, Île-deFrance - France</p>
            </Col>
            
            
       
        </Row>


        </Container>



        </div>
    )
}

export default Footer;